import { Checkbox2 } from "@/components/UI2/atoms/Checkbox";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { getAutomationDataAttr } from "@/utils/automationUtils";

type Props = {
  isAcceptingNewPatients: boolean;
  isDisabled: boolean;
  onChange: (isSelected: boolean) => void;
};

export function AcceptNewPatientsCard({ isAcceptingNewPatients, isDisabled, onChange }: Props) {
  return (
    <DashboardCard2
      Actions={
        <Checkbox2
          isDisabled={isDisabled}
          isSelected={isAcceptingNewPatients}
          onChange={onChange}
          {...getAutomationDataAttr("ProviderAcceptNewPatientsCheckbox")}
        />
      }
      classNameHeader="tw:mb-0! tw:pb-0! tw:border-b-0!"
      data-public
      rawChildren
      title="Check the box to accept new patients"
    />
  );
}
